import { isTenantManager } from "@/contexts/use-auth";
import { toast } from "sonner";

type FreshdeskSupportUser = {
  role?: string;
  managerScope?: string;
} | null | undefined;

/** Profile support — all users except admin, tenant manager, caretaker. */
export function canShowProfileSupport(user: FreshdeskSupportUser): boolean {
  const role = (user?.role ?? "").trim().toLowerCase();
  if (!role) return false;
  if (role === "admin" || role === "caretaker") return false;
  if (isTenantManager(user as Parameters<typeof isTenantManager>[0])) return false;
  return true;
}

const FRESHDESK_NEW_TICKET_URL =
  "https://anthro-help.freshdesk.com/support/tickets/new";

export function openFreshdeskPopup() {
  const popup = window.open(
    FRESHDESK_NEW_TICKET_URL,
    "freshdesk_new_ticket",
    "noopener,noreferrer,width=1280,height=900,scrollbars=yes,resizable=yes",
  );
  if (!popup) {
    toast.error("Popup was blocked. Please allow popups for this site.");
  }
}
